<mat-card>
  <mat-card-header>
    <mat-card-title>{{ data.title }}</mat-card-title>
    <button
      mat-icon-button
      (click)="toggleFullscreen()"
      class="small fullscreen-control"
    >
      @if (isFullscreen) {
        <mat-icon>close_fullscreen</mat-icon>
      } @else {
        <mat-icon>fullscreen</mat-icon>
      }
    </button>
    @if (data.hasClose) {
      <button mat-icon-button [mat-dialog-close]="false" class="small close">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-card-header>

  <form
    name="chunkItemInfoForm"
    novalidate
    [formGroup]="chunkItemInfoForm"
    (ngSubmit)="
      submitChunkInfoForm(
        chunkItemInfoForm.getRawValue(),
        chunkItemInfoForm.valid,
        $event
      )
    "
  >
    <mat-card-content>
      <div fxLayout="column" fxLayoutAlign="start" class="mb-3">
        <app-code-editor
          class="w100 mt-2"
          (updateContent)="updateContent($event)"
          (startEdit)="setFormTouched()"
          mode="markdown"
          [content]="chunkData.description || ''"
        ></app-code-editor>
      </div>
    </mat-card-content>

    <mat-card-actions [align]="'end'">
      @if (data?.updateCaption) {
        <button
          mat-stroked-button
          color="primary"
          type="submit"
          class="action-margin-right"
        >
          {{ data.updateCaption }}
        </button>
      }
      @if (data?.cancelCaption) {
        <button mat-stroked-button color="warn" [mat-dialog-close]="null">
          {{ data.cancelCaption }}
        </button>
      }
    </mat-card-actions>
  </form>
</mat-card>
